'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('urlService', function($state, $location, $window) {

  function reconstructUrl(urlPath) {
    var url = $location.protocol() + '://' + $location.host();
    if ($location.port() !== 80) {
      url += ':' + $location.port();
    }
    return url + urlPath;
  };

  function handleRedirectToIAccess(redirectPath) {
    //login success, so redirect to referral URL
    if (_.includes(['simple.memberAuthCallback'], $state.current.name)) {
      // replace the current history entry/state so we can not go back to the interstitial login page
      $window.location.replace(reconstructUrl('/members' + redirectPath));
    }
    else if (redirectPath.startsWith('//')) {
      $window.document.location.href = reconstructUrl(redirectPath.slice(1));
    }
    else {
      $window.document.location.href = reconstructUrl('/members' + redirectPath);
    }
  };

  return {
    reconstructUrl: reconstructUrl,

    pageRedirect: function (redirectPath) {
      let decodedRedirectPath = decodeURIComponent(redirectPath);

      let firstAmpersandIndex = decodedRedirectPath.indexOf('&');
      let destination, queryString;

      if (firstAmpersandIndex === -1) {
        destination = decodedRedirectPath;
        queryString = '';
      } else {
        destination = decodedRedirectPath.slice(0, firstAmpersandIndex);
        queryString = decodedRedirectPath.slice(firstAmpersandIndex + 1);
      }

      if (destination.match(/^[\/%]/)) {
        handleRedirectToIAccess(destination);
      }
      else if (destination === 'home') {
        $state.go(destination);
      }
      else {
        // replace the current history entry/state so we can not go back to the interstitial login page
        $state.go(destination, {}, {location: 'replace'}).then(() => {
          // Append the query string after $state.go finishes
          if (queryString) {
            $location.search(queryString);
          }
        });
      }
    }
  };
});
